module.exports = __webpack_public_path__ + "img/nav-bar-bg.61123b24.png";